import { render, staticRenderFns } from "./ConsultationForm.vue?vue&type=template&id=cf139a1c&scoped=true&"
import script from "./ConsultationForm.vue?vue&type=script&lang=ts&"
export * from "./ConsultationForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultationForm.vue?vue&type=style&index=0&id=cf139a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf139a1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
